export default {
  baseOption:{
    title: {
        text: '成交数量',
        subtext: '数据来自网络'
        /*left: 'left',
        textStyle: {
            color: '#999'
        }*/
    },
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        //top: 25,
        orient: 'vertical',
        data:['phpdata','北京']
    },
    grid: {
        show: true,
        left: '1%',
        right: '1%',
        //bottom: '3%',
        containLabel: true
    },
    toolbox: {
        feature: {
          dataZoom: {yAxisIndex: 'none'},
          dataView: {readOnly: false},
          saveAsImage: {}
        }
    },
    xAxis: {
      type: 'value',
      scale: true,
      position:'top'
    },
    yAxis: {
      type: 'category',
      inverse: true,
      boundaryGap: true,
      data: ['phpdata']
    },
    series: [
      {
        name:'phpdata',
        type:'bar',
        data:['phpdata'],
        markPoint: {
          data: [
            {type: 'max', name: '最大值'},
            {type: 'min', name: '最小值'}
          ]
        },
        markLine: {
          data: [
            {type: 'average', name: '平均值'}
          ]
        }
      },
      {
          name:'北京',
          type:'bar',
          data:['phpdata']
      }
    ]
  },
   media: [
      {
        option: {
          grid: {
            show: true,
            left: '1%',
            right: '1%',
            bottom: '1%',
            containLabel: true
          }
        }
      },
      {
        query: {
            maxWidth: 320              // 当容器宽度小于 500 时。
        },
        option: {
          grid: {
            show: true,
            left: '1%',
            right: '1%',
            bottom: '30%',
            containLabel: true
          }
        }
      }
  ]
}



// WEBPACK FOOTER //
// ./src/data/bar.js